import { useEffect, useState } from 'react';

const MQL = typeof window !== 'undefined' ? window.matchMedia('(max-width: 768px)') : null;

/** True when the viewport is narrow enough to trigger the mobile layout. */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => (MQL ? MQL.matches : false));

  useEffect(() => {
    if (!MQL) return;
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    MQL.addEventListener('change', onChange);
    return () => MQL.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

export default useIsMobile;
